import { getComponentClasses } from '@99designs/frontend-components/utils/app';
import React from 'react';

interface Props {
    [key: string]: any;
    type?: 'div' | 'p';
    variations?: string[];
    children: React.ReactNode;
}

function Paragraph({ variations, children, type = 'p', ...props }: Props) {
    const className = getComponentClasses('paragraph', variations);
    return React.createElement(type, { className, ...props }, children);
}

export function NarrowParagraph({ children, variations = [], ...other }: Props) {
    return (
        <Paragraph variations={[...variations, 'narrow']} {...other}>
            {children}
        </Paragraph>
    );
}

export function NoMarginParagraph({ children, variations = [], ...other }: Props) {
    return (
        <Paragraph variations={[...variations, 'no-margin']} {...other}>
            {children}
        </Paragraph>
    );
}

export default Paragraph;
